import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Checkbox, CircularProgress } from "@mui/material";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import {
  calculateTaxForPoint,
  calculateTotalAmountForPoint,
} from "utils/payment";
import { IPointsPlan, setPointsPlaneToPurchase } from "redux/reducers";
import usePurchaseSelector from "redux/selectors/purchaseSelectors";
import { useAppDispatch } from "redux/store/hooks";
import { getPointsPlans } from "redux/actions/purchase";

const PurchasePointsTable: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { loading, pointsPlans, pointsPlanToPurchase } = usePurchaseSelector();

  useEffect(() => {
    dispatch(getPointsPlans());
  }, []);

  const getTableRows = (pointsPlans: IPointsPlan[], loading: boolean) => {
    if (loading) {
      return (
        <TableRow>
          <TableCell colSpan={5}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={2}
            >
              <CircularProgress size={20} color="success" />
            </Box>
          </TableCell>
        </TableRow>
      );
    }
    return pointsPlans.map((pointsPlan, index) => (
      <TableRow
        key={pointsPlan.id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <Checkbox
            size="small"
            value={pointsPlan.id}
            checked={pointsPlanToPurchase?.id === pointsPlan.id}
            onChange={(_, checked) => {
              if (checked) {
                dispatch(setPointsPlaneToPurchase(pointsPlan));
              }
            }}
          />
        </TableCell>
        <TableCell component="td" scope="row">
          <span>{pointsPlan.amount}</span> {t("common.points")}
        </TableCell>
        <TableCell>{pointsPlan.amount}</TableCell>
        <TableCell>{calculateTaxForPoint(pointsPlan)}</TableCell>
        <TableCell>{calculateTotalAmountForPoint(pointsPlan)}</TableCell>
      </TableRow>
    ));
  };

  return (
    <React.Fragment>
      <div className="page_heading">
        {t("purchasePoints.label.pointsTitle")}
      </div>
      <div className="points_table">
        <TableContainer component={Paper} className="tbl_points">
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center"></TableCell>
                <TableCell align="center">
                  {t("purchasePoints.table.columnHeader.points")}
                </TableCell>
                <TableCell align="center">
                  {t("purchasePoints.table.columnHeader.lessonFee")}
                </TableCell>
                <TableCell align="center">
                  {t("purchasePoints.table.columnHeader.tax")}
                </TableCell>
                <TableCell align="center">
                  {t("purchasePoints.table.columnHeader.total")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{getTableRows(pointsPlans, loading)}</TableBody>
          </Table>
        </TableContainer>
      </div>
    </React.Fragment>
  );
};

export default PurchasePointsTable;
